import React from 'react';
import compact from 'lodash/compact';
import { useOverlayContext, useStoreActions } from "../../../contexts";
import { Intent } from "../../../infra/access-control";
import ApproveAllModal from "./ApproveAllModal";
import { Banner } from "../Banner";

/* eslint-disable @typescript-eslint/ban-ts-comment */
/* @ts-ignore */
const listFormatter = new Intl.ListFormat();
export default function ApproveAllBar(_ref) {
  let {
    agreement,
    onClose,
    amendments,
    invoices,
    charges
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const approvalType = compact([charges > 0 && 'charges', invoices > 0 && 'invoices', amendments > 0 && 'amendments']);
  return /*#__PURE__*/React.createElement(Banner, {
    "data-testid": "approve-all-banner",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "There are ", /*#__PURE__*/React.createElement("strong", null, listFormatter.format(approvalType)), " awaiting your approval."),
    actionButtonLabel: "Review and approve",
    actionButtonIntent: Intent.ApproveAllBar,
    actionButtonOnClick: async e => {
      e.preventDefault();
      logBI(10587);
      await overlayContext.showModal({
        content: _ref2 => {
          let {
            dismissModal: _dismissModal
          } = _ref2;
          return /*#__PURE__*/React.createElement(ApproveAllModal, {
            agreement: agreement,
            amendments: amendments,
            invoices: invoices,
            charges: charges,
            dismissModal: _ref3 => {
              let {
                status
              } = _ref3;
              _dismissModal();
              onClose({
                status
              });
            }
          });
        }
      });
    },
    closeButtonOnClick: () => onClose({
      status: 'dismissed'
    })
  });
}